import { render, staticRenderFns } from "./ListadoSedeUniversidad.vue?vue&type=template&id=02bd55fe"
import script from "./ListadoSedeUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoSedeUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoSedeUniversidad.vue?vue&type=style&index=0&id=02bd55fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports